<template>
  <div>
    <q-dialog v-if="flModal" v-model="flModal">
      <q-layout view="Lhh lpR fff" container class="bg-white modal-large">
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title
              ><translate>RESULT_FILTERS</translate>
              {{ nmInterface }}</q-toolbar-title
            >
            <q-btn v-close-popup flat round dense size="1.5em" icon="cancel" />
          </q-toolbar>
        </q-header>
        <q-page-container style="max-height: calc(75vh - 20px)" class="q-ma-lg">
            <crud-layout-search
                ref="crudLayoutSearch"
                interface="controlBatch.scheduleOrder"
                :page="page"
            />
        </q-page-container>
      </q-layout>
    </q-dialog>
  </div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import { repository } from 'jtech'
import { JtCrud } from 'jtech-webcomps'
const { page, CrudLayoutSearch } = JtCrud

@Component({
  mixins: [page],
  components: {
    CrudLayoutSearch
  },
  props: {
    filterParams: Object,
    multiselect: {
      type: Boolean,
      default: false
    },
    nmInterface: {
      type: String,
      required: true
    },
    flModal: {
      type: Boolean,
      default: false
    }
  }
})
class ModalScheduleOrder extends Vue {
  onClose () {
    this.$emit('close')
  }

  onOpen () {
    this.$emit('open')
  }
}
export default ModalScheduleOrder
</script>
<style lang="stylus" scoped>
#truck-weight-capacity-search-modal {
  .q-card {
    #pesquisa-table-container {
      position: initial;
      height: calc(100% - 64px);
      overflow: auto;
      padding: 0;
    }
  }

  .q-table-container {
    height: 100%;
    overflow: hidden;
  }

  .q-table-middle.scroll {
    height: calc(100% - 50px);
  }
}

.table-search{
  .q-tr, .q-td {
    padding: 5px!important;
   }

}

.header-dialog {
  margin: 10px;
  border-radius: 5px;
}
</style>
